
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meet-the-team/[url_slug]",
      function () {
        return require("private-next-pages/meet-the-team/[url_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meet-the-team/[url_slug]"])
      });
    }
  